<template>
    <div>
        <div v-if="!!attachments">
            <v-badge color="primary" overlap bordered offset-y="9" offset-x="9">
                <template v-slot:badge>
                    <span>{{ attachments }}</span>
                </template>
                <v-btn color="primary" small block v-on:click="m_attm(entity, entitykey, '', '', encrid)">
                    <v-icon small style="minwidth: 0;">mdi-paperclip</v-icon><span>&nbsp;attachments</span>
                </v-btn>
            </v-badge>
        </div>
        <div v-else>
            <v-btn color="primary" small block v-on:click="m_attm(entity, entitykey, '', '', encrid)">
                <v-icon small style="minwidth: 0;">mdi-paperclip</v-icon><span>&nbsp;attachments</span>
            </v-btn>
        </div>
        <m_attm ref="m_attm" @updateData="updateData"/>
    </div>
</template>

<script>

import m_attm from "@/components/m_attm.vue";

export default {
    props: {
        attachments: Number,
        encrid: String,
        entity: String,
        entitykey: String,
    },
    components: {
        m_attm
    },
    data() {
        return {
        }
    },
    methods: {
        m_attm(table, key1, key2, parent, encrid) {
            this.$refs.m_attm.open(table, key1, key2, parent, encrid, null);
        },
        updateData(data){
            console.log('attm_button', 'send updateData');
            this.$emit('updateData', data);
        }
    }
}
</script>

<style scoped></style>